import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { DateFormat, Language, NumberFormatPreference, userConfigStore } from "@/store/user-config-store";
import { useTranslation } from "react-i18next";

export function RegionalSection() {
  const { t } = useTranslation("user-settings");
  const language = userConfigStore((state) => state.language);
  const dateFormat = userConfigStore((state) => state.dateFormat);
  const numberFormatPreference = userConfigStore((state) => state.numberFormatPreference);
  const setLanguage = userConfigStore((state) => state.setLanguage);
  const setDateFormat = userConfigStore((state) => state.setDateFormat);
  const setNumberFormatPreference = userConfigStore((state) => state.setNumberFormatPreference);

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Regional")}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between gap-4">
          <Label className="text-sm font-medium">{t("Language")}</Label>
          <Select value={language} onValueChange={(value) => setLanguage(value as Language)}>
            <SelectTrigger className="w-40">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={Language.German}>{t("LanguageGerman")}</SelectItem>
              <SelectItem value={Language.English}>{t("LanguageEnglish")}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center justify-between gap-4">
          <Label className="text-sm font-medium">{t("DateFormat")}</Label>
          <Select value={dateFormat} onValueChange={(value) => setDateFormat(value as DateFormat)}>
            <SelectTrigger className="w-52">
              <SelectValue className="truncate" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={DateFormat.EuropeanDot}>{t("DateFormatEuropean")}</SelectItem>
              <SelectItem value={DateFormat.EuropeanSlash}>{t("DateFormatEuropeanSlash")}</SelectItem>
              <SelectItem value={DateFormat.US}>{t("DateFormatUS")}</SelectItem>
              <SelectItem value={DateFormat.ISO}>{t("DateFormatISO")}</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center justify-between gap-4">
          <Label className="text-sm font-medium">{t("NumberFormat")}</Label>
          <Select
            value={numberFormatPreference}
            onValueChange={(value) => setNumberFormatPreference(value as NumberFormatPreference)}
          >
            <SelectTrigger className="w-52">
              <SelectValue className="truncate" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={NumberFormatPreference.FollowLanguage}>{t("NumberFormatFollowLanguage")}</SelectItem>
              <SelectItem value={NumberFormatPreference.German}>{t("NumberFormatGerman")}</SelectItem>
              <SelectItem value={NumberFormatPreference.EnglishUS}>{t("NumberFormatEnglishUS")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
